import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as IBooks from '../../../../../../../interfaces/merchants/resources/books';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';

import css from './BooksOptionsList.module.scss';

interface Props extends React.HTMLProps<{}> {
  options: IBooks.Option[];
  checkedOptions: IBooks.Option[];
  onChange?: (e: React.ChangeEvent) => void;
}

const BooksOptionsList = ({
  className,
  options,
  checkedOptions,
  onChange,
}: Props) => {
  const classes = classNames(css.BooksOptionsList, className);
  const intl = useIntl();

  return (
    <ul className={classes}>
      {options.map((option) => (
        <li key={option.id} className={css.BooksOptionsList__ListItem}>
          <CheckInput
            type={InputType.Checkbox}
            name="options"
            value={option.id}
            checked={!!checkedOptions.find((o) => o.id === option.id)}
            labelPosition="SpaceBetween"
            onChange={onChange}
          >
            <div className={css.BooksOptionsList__OptionInner}>
              <span className={css.BooksOptionsList__Name}>{option.name}</span>
              <span className={css.BooksOptionsList__Time}>
                (
                <FormattedMessage
                  id="books.optionsList.time"
                  values={{ time: intl.formatNumber(option.duration / 60) }}
                />
                )
              </span>
            </div>
            <span className={css.BooksOptionsList__Price}>
              {option.price && (
                <FormattedMessage
                  id="books.optionsList.price"
                  values={{ price: option.price }}
                />
              )}
            </span>
          </CheckInput>
          {option.description && (
            <span className={css.BooksOptionsList__Description}>
              {option.description}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default BooksOptionsList;
